
import renderers from '../renderers/analytics.js';

export default {
    renderers
};
